import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  nameColumnHeader: {
    defaultMessage: 'Name',
    id: 'HHaU/o',
    description: 'Header for the name column in custom packages table.',
  },
  lengthColumnHeader: {
    defaultMessage: 'Length ({unit})',
    id: 'jHoShL',
    description: 'Header for the length column in custom packages table.',
  },
  widthColumnHeader: {
    defaultMessage: 'Width ({unit})',
    id: '2mByC4',
    description: 'Header for the width column in custom packages table.',
  },
  heightColumnHeader: {
    defaultMessage: 'Height ({unit})',
    id: 'WrQ15s',
    description: 'Header for the height column in custom packages table.',
  },
  actionsColumnHeader: {
    defaultMessage: 'Actions',
    id: 'rJh7nh',
    description: 'Header for the actions column in custom packages table.',
  },
  editPackage: {
    defaultMessage: 'Edit',
    id: 'ejx14h',
    description: 'Button to edit a custom package.',
  },
  deletePackage: {
    defaultMessage: 'Delete',
    id: 'wWVKst',
    description: 'Button to delete a custom package.',
  },
  emptyBoxMessage: {
    defaultMessage: 'You do not have any custom packages',
    id: 'Huw7Dn',
    description: 'Message to display when there are no custom packages available.',
  },
  emptyCustomPackagesInstructions: {
    defaultMessage: 'Select the "Add Custom Package" button to get started.',
    id: 'n5gSGz',
    description: 'Instructions to add a custom package.',
  },
  altImageText: {
    defaultMessage: 'Empty Box',
    id: 'uj1g6g',
    description: 'Alt text for the empty box image.',
  },
  cm: {
    defaultMessage: 'cm',
    id: '4U+OIS',
    description: 'Abbreviation for centimeters in the custom packages table column headers.',
  },
  in: {
    defaultMessage: 'in',
    id: 'SRO9Oc',
    description: 'Abbreviation for inches in the custom packages table column headers.',
  },
  tareWeightColumnHeader: {
    defaultMessage: 'Tare Weight ({unit})',
    id: 'Nk0ieH',
    description: 'Header for the tare weight column in custom packages table.',
  },
  maxWeightColumnHeader: {
    defaultMessage: 'Max Weight ({unit})',
    id: '1VMzdN',
    description: 'Header for the max weight column in custom packages table.',
  },
  oz: {
    defaultMessage: 'oz',
    id: 'DQcDrJ',
    description: 'Abbreviation for ounces in the custom packages table column headers.',
  },
  lbs: {
    defaultMessage: 'lbs',
    id: 'TzJy9n',
    description: 'Abbreviation for pounds in the custom packages table column headers.',
  },
  g: {
    defaultMessage: 'g',
    id: 'POSOOm',
    description: 'Abbreviation for grams in the custom packages table column headers.',
  },
  kg: {
    defaultMessage: 'kg',
    id: 'Cpz7RN',
    description: 'Abbreviation for kilograms in the custom packages table column headers.',
  },
});
